import getCheggEnv, { CheggEnv } from '../getCheggEnv';
import getCheggTldFrom from './getCheggTldFrom';
/**
 * Similar to getCheggTldFrom, getCheggDomainFrom returns the full domain with TLD instead of only the TLD.
 * For example, "chegg.com", "chegg.com.mx"
 */
export default function getCheggDomainFrom(from) {
  var tld = getCheggTldFrom(from) || '.com';
  return getCheggEnv() === CheggEnv.PROD ? "chegg".concat(tld) : "cheggnet".concat(tld);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/urls/getCheggDomainFrom.js
// module id = 2866
// module chunks = 11